;(function() {
  // 折扣进度条
  let discountStatus = {
    totalMoney: 0,
    discount: '',
    level: -1,
    dirty: ''
  }
  const discountRule = {
    'Free Shipping': 10500,
    'Save 5%': 15000,
    'Save 10%': 45000,
    'Save 15%': 75000
  }
  
  init()
  watchCartList()
  
  // 初始化入口
  function init() {
    resetStatus()
    initDiscountStatus()
    renderDiscountProgress()
  }

  function resetStatus() {
    discountStatus = {
      totalMoney: 0,
      discount: '',
      level: -1,
      dirty: ''
    }
    const discountDom = document.querySelector(".cart-discount-progress")
    if(discountDom) {
      discountDom.parentNode.removeChild(discountDom)
    }
  }
  
  // 获取购物车的折扣状态
  function initDiscountStatus() {
    // 初始化购物车总金额
    const cartDrawerItems = Array.from(document.querySelectorAll(".m-cart-drawer--item"))
    discountStatus.dirty = document.querySelector(".m-cart-drawer .m-cart--totals .transcy-money").innerHTML
    
    cartDrawerItems.forEach(item => {
      const price = filterNumber(item.getAttribute("data-price"))
      const count = item.querySelector(".m-cart-quantity--input").value
      discountStatus.totalMoney += price * count
    })
    // 初始化折扣以及折扣等级
    Object.keys(discountRule).forEach((discount, index) => {
      if(discountRule[discount] < discountStatus.totalMoney) {
        discountStatus.discount = discount
        discountStatus.level = index
      }
    })
  }
  
  // 从一个字符串中提取数字
  function filterNumber(str) {
    const regex = /\D/g // 匹配非数字字符
    return parseInt(str.replace(regex, ""))
  }

    // 渲染折扣进度条
  function renderDiscountProgress() {
    const progressHtml = generateDiscountProgressHtml()
    const cartHedaer = document.querySelector('.m-cart-drawer--header')
    cartHedaer.insertAdjacentHTML('afterend', progressHtml)
  }

  // 生成折扣进度条的结构
  function generateDiscountProgressHtml() {
    let progressItemsHtml = ``
    let diffPrice = 0
    let diffDiscount = '15%'
    const tempLevel = discountStatus.level
    if(Object.values(discountRule)[tempLevel + 1]) {
      diffPrice = Object.values(discountRule)[tempLevel + 1] - discountStatus.totalMoney
      diffDiscount = Object.keys(discountRule)[tempLevel + 1]
    }
    
    Object.keys(discountRule).forEach((discount, index) => {
      let svgHtml
      let progressWidth = ''
      if(discountStatus.totalMoney > discountRule[discount]) {
        progressWidth = '100%'
      } else {
        const prevDiscountMoney = Object.values(discountRule)[index - 1] ? Object.values(discountRule)[index - 1] : 0
        const nextDiscountMoney = discountRule[discount]
        if(prevDiscountMoney > discountStatus.totalMoney) {
          progressWidth = '0%'
        } else {
          progressWidth = `${((discountStatus.totalMoney - prevDiscountMoney) / (nextDiscountMoney - prevDiscountMoney))*100}%`
        }
      }
      
      if(index <= discountStatus.level) {
        svgHtml = `
        <svg t="1714115090188" active="" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4297" width="200" height="200"><path d="M613.64419 80.822857L866.011429 108.032a73.142857 73.142857 0 0 1 64.902095 64.877714l27.184762 252.391619a73.142857 73.142857 0 0 1-20.992 59.538286L512.707048 909.238857a73.142857 73.142857 0 0 1-103.448381 0L129.706667 629.662476a73.142857 73.142857 0 0 1 0-103.424L554.081524 101.839238a73.142857 73.142857 0 0 1 59.562666-21.016381z m-7.826285 72.728381L181.394286 577.950476l279.576381 279.576381 424.399238-424.399238-27.209143-252.367238-252.367238-27.209143zM674.279619 243.809524a109.714286 109.714286 0 1 1 0 219.428571 109.714286 109.714286 0 0 1 0-219.428571z m0 73.142857a36.571429 36.571429 0 1 0 0 73.142857 36.571429 36.571429 0 0 0 0-73.142857z" p-id="4298" fill="#E2E2E2"></path></svg>
        `
      } else {
        svgHtml = `<svg t="1714115090188" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4297" width="25" height="25"><path d="M613.64419 80.822857L866.011429 108.032a73.142857 73.142857 0 0 1 64.902095 64.877714l27.184762 252.391619a73.142857 73.142857 0 0 1-20.992 59.538286L512.707048 909.238857a73.142857 73.142857 0 0 1-103.448381 0L129.706667 629.662476a73.142857 73.142857 0 0 1 0-103.424L554.081524 101.839238a73.142857 73.142857 0 0 1 59.562666-21.016381z m-7.826285 72.728381L181.394286 577.950476l279.576381 279.576381 424.399238-424.399238-27.209143-252.367238-252.367238-27.209143zM674.279619 243.809524a109.714286 109.714286 0 1 1 0 219.428571 109.714286 109.714286 0 0 1 0-219.428571z m0 73.142857a36.571429 36.571429 0 1 0 0 73.142857 36.571429 36.571429 0 0 0 0-73.142857z" p-id="4298" fill="#6ccd66"></path></svg>`
      }
      
      progressItemsHtml += `
        <div class="cart-discount-progress-item">
            <div class="discount-progress-bar-container" ${index === 0? 'style="border-radius: 30px;"' : ''}>
              <div class="discount-progress-bar" style="width:${progressWidth}; ${index === 0? 'border-radius: 30px;' : ''}"></div>
            </div>
            <div class="discount-progress-icon">
                ${svgHtml}
                <div class="discount-info">
                     ${discount}!
                </div>
            </div>
        </div>
      `
    })

    return `
      <div class="cart-discount-progress">
        <div class="cart-discount-progress-title">
            You're ¥${diffPrice} away from product ${diffDiscount} !
        </div>
        <div class="cart-discount-progress-content">
          ${progressItemsHtml}
        </div>
      </div>
    `
  }

  // 监听列表长度变化
  function watchCartList() {
    setInterval(() => {
      const newVal = document.querySelector(".m-cart-drawer .m-cart--totals .transcy-money").innerHTML
      if(newVal !== discountStatus.dirty) {
        init()
      }
    }, 200)
  }

})()

// 推荐栏位
;(function() {
  
})()